import { render, staticRenderFns } from "./department-settings.vue?vue&type=template&id=cf3f2054&"
import script from "./department-settings.vue?vue&type=script&lang=js&"
export * from "./department-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports